import { Box, Button, Drawer, IconButton, Typography, useMediaQuery } from "@mui/material"
import { DoubleArrow } from "@mui/icons-material"
import theme from "src/theme/light"

interface InformationDrawerHibridoProps{
  isOpen: boolean
  close: () => void
}

interface TitleProps {
  text: string
}

interface Item {
  title?: string;
  items: string[]
}

const WHATSAPP_PHONE = "(48) 2106-0006"
const WHATSAPP_URL = `https://api.whatsapp.com/send?phone=55${WHATSAPP_PHONE.replace(/\D/g, '')}`

const items: {[index: string]: Item[]} = {
  'Tipo de bateria': [{
    items: [
      'A principal diferença está no armazenamento:',
      'Sistemas híbridos com bateria garantem energia mesmo sem rede, enquanto sem bateria dependem da disponibilidade da concessionária.'
    ],
  }],
  'Taxa de descarga': [{
    items: [
      'A taxa de descarga, expressa em C‑rate, indica quão rápido a bateria entrega sua energia em relação à sua capacidade total.',
      '- 0,5C: a bateria é descarregada em cerca de 2 horas',
      '- 1C: a bateria é descarregada em cerca de 1 hora'
    ]}
  ],
  'Tipo de ligação': [{
    items: [
      '<b>Monofásico</b>',
      'No local de instalação chegam <b>uma</b> Fase e <b>um</b> Neutro da rede da concessionária/cooperativa.',
      '<br/>',
      '<b>Bifásico</b>',
      'No local de instalação chegam <b>duas</b> Fases e <b>um</b> Neutro da rede da concessionária/cooperativa.',
      '<br/>',
      '<b>Trifásico</b>',
      'No local de instalação chegam <b>três</b> Fases e <b>um</b> Neutro da rede da concessionária/cooperativa.'
    ]
  }],
  'Tipo de estrutura': [{
    items: [
      'A recomendação das estruturas considerará a disposição dos módulos em uma (1) fileira e na posição selecionada (retrato ou paisagem). Esta informação poderá ser alterada na tela de Solução em “Editar estruturas”.'
    ]
  }],
  // 'Dúvidas': [{
  //   items: [
  //     `Em caso de dúvidas,  consulte a conta de luz do cliente ou nos ligue pelo telefone e whatsapp: <a target="_blank" href=${WHATSAPP_URL}>${WHATSAPP_PHONE}</a>`
  //   ]
  // }]
}


const Title = ({ text }: TitleProps) => {
  return (
    <Box my={4} className="drawer-hibrido-title">
      <Typography variant="h5" color="primary"><strong>{text}</strong></Typography>
    </Box>
  )
}

export function InformationDrawerHibrido({ isOpen, close }: InformationDrawerHibridoProps){
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Drawer anchor="right" open={isOpen} onClose={close} className="drawer-hibrido-info">
      <Box className="drawer-container">
        <Box className="drawer-content">
          { !isMobile && (
            <Box width="40px" height="40px" margin="18px 0 0 18px">
              <IconButton onClick={close} aria-label="Fechar drawer" size="large">
                <DoubleArrow />
              </IconButton>
            </Box>
          )}

          <Box width={isMobile ? "auto" : "430px"} px={isMobile ? 2 : 4} mb={4} mt={isMobile ? 10 : 'unset'}>
            {Object.keys(items).map((title) => {
              const item = items[title]

              return (
                <>
                  <Title text={title} />
                  {item.map(register => {
                    return (
                      <Box mt={4} className="drawer-hibrido-text">
                        {register.title && <Typography variant='body1' color="textSecondary"><strong>{register.title}</strong></Typography>}
                        {register.items.map(item => {
                          return <div style={{ color: theme.palette.text.secondary, fontSize: 16  }} dangerouslySetInnerHTML={{__html: item}}></div>
                        })}
                      </Box>
                    )
                  })}
                </>
              )
            })}
          </Box>
        </Box>

        { isMobile && (
          <Box mb={4} className="drawer-footer">
            <Button onClick={close} fullWidth variant="outlined" color="secondary" className="close-btn">
              Fechar
            </Button>
          </Box>
        )}
      </Box>
    </Drawer>
  );
}
